import "./lib/browser-compat";
import "./instrumentation-client";
import { StrictMode, startTransition } from "react";
import { hydrateRoot } from "react-dom/client";
import { StartClient } from "@tanstack/react-start/client";
import { reportRecoverableHydrationError } from "@/lib/browser-error-diagnostics";

startTransition(() => {
  hydrateRoot(document, <StrictMode><StartClient /></StrictMode>, {
    onRecoverableError: reportRecoverableHydrationError,
  });
});
